import { useEffect, useState } from "react";
import config from "config/index";
import CustomLink from "@Components/CustomLink";
import {
  footerListLeft,
  footerListRight,
  footerListLeftChina,
  footerListRightChina,
} from "./constant";
import classes from "./FooterV2.module.scss";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import getImagePath from "@Utils/getImagePath";
import {
  AMBER_LOGO_URL,
  BLOG_URL,
  CONTACT_URL,
  EXAMS_URL,
  PRIVACY_URL,
  SITEMAP_URL,
  TERMS_URL,
} from "constants/configConstants";
import getWeComUrlBasedOnSource, { HK_WEIXIN_MWEB } from "helpers/getWeComUrlBasedOnSource";
import getSiteNavSchema from "./util";
import FollowUsChina from "./components/FollowUs/FollowUsChina";
import FollowUs from "./components/FollowUs/FollowUs";
import AppDownload from "./components/AppDownload/AppDownload";
import ContactCard from "./components/ContactCard/ContactCard";
import LazyImage from "@Components/Image";
import Chevron from "@Icons/Chevron";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import useTranslationHook from "hooks/useTranslationHook";
import useTranslatedList from "./useTranslatedFooterLists";
import wrapperHOC from "@Utils/wrapperHOC";
import useIsMiniProgram from "hooks/useIsMiniProgram";
import TrustPilotDynamicWidget from "@Components/TrustPilotDynamicWidget";
import useIsDesktop from "hooks/useIsDesktop";
import useIsApp from "hooks/useIsApp";
import { useSelector, shallowEqual } from "react-redux";
import { AppState } from "@Store/index";
import { isRegionalBlogLanguage } from "@Pages/Blog/utils/blogLanguage";
import { useLanguagePath } from "hooks/useLanguagePath";

const FooterV2mobile = ({ contactDetails }: any) => {
  const date = new Date();
  const year = date.getFullYear();
  const { t } = useTranslationHook();
  const isMiniProgram = useIsMiniProgram();
  const { getLocalizedPath } = useLanguagePath();
  const [isDescriptionOpen, setisDescriptionOpen] = useState({
    company: false,
    discover: false,
    support: false,
    contactus: false,
  });
  const handleClickEvent = (buttonName: any) => {
    gtagEventEmitter({
      action: "bottom_button_clicked",
      category: "Footer Section",
      button_name: buttonName,
    });
  };

  const isDesktop = useIsDesktop();
  const isApp = useIsApp();
  const userLanguage = useSelector(({ appData }: AppState) => appData.userLanguage);
  const blogUrl = isRegionalBlogLanguage(userLanguage) ? `/${userLanguage}/blog` : "/blog";

  const [weChatSupportRedirectTo, setWeChatSupportRedirectTo] = useState(HK_WEIXIN_MWEB);
  const footerListLeftTrans = useTranslatedList(footerListLeft, ["name", "extraText"]);
  const footerListRightTrans = useTranslatedList(footerListRight, ["name", "extraText"]);
  const footerListLeftTransCn = useTranslatedList(footerListLeftChina, ["name", "extraText"]);
  const footerListRightTransCn = useTranslatedList(footerListRightChina, ["name", "extraText"]);
  const helpCenterText = t("searchpage.globalfooter.helpcenter");
  const contactText = t("searchpage.globalfooter.contact");
  const privacyPolicy = t("searchpage.globalfooter.privacypolicy");
  const sitemapText = t("searchpage.globalfooter.sitemap");

  useEffect(() => {
    const { URLMweb } = getWeComUrlBasedOnSource();
    setWeChatSupportRedirectTo(URLMweb);
  }, []);

  const contactDetailsUpdated = contactDetails?.map((detail: any) => {
    if (detail.label === "WeChat") {
      return {
        ...detail,
        link: isDesktop ? detail?.link : weChatSupportRedirectTo,
      };
    }
    if (detail.label === "+91 8035735724" && config.IS_CHINA_APP) {
      return <></>;
    }
    return detail;
  });

  const footerListLeftWithGaKey = footerListLeftTrans.map((item: any, index: number) => ({
    ...item,
    gaKey: footerListLeft[index]?.gaKey,
  }));

  const footerListRightWithGaKey = footerListRightTrans.map((item: any, index: number) => ({
    ...item,
    gaKey: footerListRight[index]?.gaKey,
  }));

  const footerListLeftWithGaKeyCn = footerListLeftTransCn.map((item: any, index: number) => ({
    ...item,
    gaKey: footerListLeft[index]?.gaKey,
  }));

  const footerListRightWithGaKeyCn = footerListRightTransCn.map((item: any, index: number) => ({
    ...item,
    gaKey: footerListRight[index]?.gaKey,
  }));

  useEffect(() => {
    const closeZendeskWidgetBeforeUnload = () => {
      // if (typeof zE === "function") {
      //   zE("messenger", "close");
      // }
    };

    window.addEventListener("beforeunload", closeZendeskWidgetBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", closeZendeskWidgetBeforeUnload);
    };
  }, []);

  const nonce = useSelector(({ appData }: AppState) => appData.nonce, shallowEqual);
  if (isApp) {
    return <div className={classes.extraSpace} />;
  }

  return (
    <div>
      <div className={classes.imageContainer}>
        <LazyImage
          dataTestId="footer-amber-logo"
          src={
            config.IS_CHINA_APP
              ? `${config.IMAGE_STATIC_URL}/images/logo/amber-china-logo-dark.svg?auto=format&q=40`
              : getImagePath(AMBER_LOGO_URL)
          }
          className={config.IS_CHINA_APP ? classes.amberImgChina : classes.amberImg}
          alt="amber-div"
          width="86.564px"
          height="34.05px"
        />
        <div
          data-testid="footer-amber-rights-reserved"
          className={classes.subHeading}
        >{`amber © ${year}. ${t("searchpage.globalfooter.allrightsreserved")}.`}</div>
      </div>
      <div
        className={
          config.IS_CHINA_APP
            ? `${classes.trustpilotWrapper} ${classes.trustpilotWrapperChina}`
            : classes.trustpilotWrapper
        }
      >
        <TrustPilotDynamicWidget chinaVariant="footerChina" />
      </div>

      <AppDownload />
      <div>
        <div
          style={{
            borderBottom: `1px solid rgb(222, 226, 230)`,
          }}
        >
          <div
            data-testid="footer-company-section"
            className={classes.sectionHeadingMobile}
            onClick={() =>
              setisDescriptionOpen({ ...isDescriptionOpen, company: !isDescriptionOpen.company })
            }
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                setisDescriptionOpen({ ...isDescriptionOpen, company: !isDescriptionOpen.company });
              }
            }}
          >
            {t("searchpage.globalfooter.company")}
            <div
              className={
                isDescriptionOpen.company
                  ? formatClassNames(classes.chevron, classes.active)
                  : classes.chevron
              }
            >
              <Chevron />
            </div>
          </div>

          <div>
            <div>
              {isDescriptionOpen.company &&
                !config.IS_CHINA_APP &&
                footerListLeftWithGaKey.map((item: any, index: any) => (
                  <>
                    {isMiniProgram && item?.name === "Partner with us" ? null : (
                      <div
                        className={classes.listItem}
                        key={index}
                        data-testid={`mobile-footer-${item.name}`}
                      >
                        <script
                          type="application/ld+json"
                          nonce={nonce}
                          suppressHydrationWarning
                          dangerouslySetInnerHTML={{
                            __html: getSiteNavSchema(item.name, item.link),
                          }}
                        />
                        <CustomLink
                          href={item.localize ? getLocalizedPath(item.link) : item.link}
                          target="_blank"
                          rel="noreferrer"
                          isExternal
                          dataTestId={item.name}
                          onClick={() => handleClickEvent(item.gaKey)}
                        >
                          {item.name}
                        </CustomLink>
                        {item.extraText && <span>{item.extraText}</span>}
                      </div>
                    )}
                  </>
                ))}
              {isDescriptionOpen.company &&
                config.IS_CHINA_APP &&
                footerListLeftWithGaKeyCn.map((item: any, index: any) => (
                  <>
                    {isMiniProgram && item?.name === "Partner with us" ? null : (
                      <div
                        className={classes.listItem}
                        key={index}
                        data-testid={`mobile-footer-${item.name}`}
                      >
                        <script
                          type="application/ld+json"
                          nonce={nonce}
                          suppressHydrationWarning
                          dangerouslySetInnerHTML={{
                            __html: getSiteNavSchema(item.name, item.link),
                          }}
                        />
                        <CustomLink
                          href={item.link}
                          target="_blank"
                          rel="noreferrer"
                          isExternal
                          dataTestId={item.name}
                          onClick={() => handleClickEvent(item.gaKey)}
                        >
                          {item.name}
                        </CustomLink>
                        {item.extraText && <span>{item.extraText}</span>}
                      </div>
                    )}
                  </>
                ))}
            </div>
          </div>
        </div>

        <div
          style={{
            borderBottom: `1px solid rgb(222, 226, 230)`,
          }}
        >
          <div
            data-testid="footer-discover-section"
            className={classes.sectionHeadingMobile}
            onClick={() =>
              setisDescriptionOpen({ ...isDescriptionOpen, discover: !isDescriptionOpen.discover })
            }
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                setisDescriptionOpen({
                  ...isDescriptionOpen,
                  discover: !isDescriptionOpen.discover,
                });
              }
            }}
          >
            {t("searchpage.globalfooter.discover")}
            <div
              className={
                isDescriptionOpen.discover
                  ? formatClassNames(classes.chevron, classes.active)
                  : classes.chevron
              }
            >
              <Chevron />
            </div>
          </div>
          <div>
            {isDescriptionOpen.discover &&
              !config.IS_CHINA_APP &&
              footerListRightWithGaKey.map((item: any, index: any) => {
                let href = item.link;
                if (item.link === BLOG_URL) href = blogUrl;
                else if (item.localize) href = getLocalizedPath(item.link);
                return (
                  <>
                    {isMiniProgram && item?.name === "Amber Plus" ? null : (
                      <div
                        className={formatClassNames(
                          classes.listItem,
                          item.link === EXAMS_URL && classes.hiddenForUsers,
                        )}
                        key={index}
                        data-testid={`mobile-footer-${item.name}`}
                      >
                        <script
                          type="application/ld+json"
                          suppressHydrationWarning
                          dangerouslySetInnerHTML={{
                            __html: getSiteNavSchema(
                              item.name,
                              item.link === BLOG_URL ? blogUrl : item.link,
                            ),
                          }}
                        />
                        <CustomLink
                          href={href}
                          target="_blank"
                          rel="noreferrer"
                          isExternal
                          dataTestId={item.name}
                          onClick={() => handleClickEvent(item.gaKey)}
                        >
                          {item.name}
                        </CustomLink>
                        {item.extraText && <span>{item.extraText}</span>}
                      </div>
                    )}
                  </>
                );
              })}
            {isDescriptionOpen.discover &&
              config.IS_CHINA_APP &&
              footerListRightWithGaKeyCn.map((item: any, index: any) => (
                <>
                  {isMiniProgram && item?.name === "Amber Plus" ? null : (
                    <div
                      className={classes.listItem}
                      key={index}
                      data-testid={`mobile-footer-${item.name}`}
                    >
                      <script
                        type="application/ld+json"
                        suppressHydrationWarning
                        dangerouslySetInnerHTML={{
                          __html: getSiteNavSchema(item.name, item.link),
                        }}
                      />
                      <CustomLink
                        href={item.link}
                        target="_blank"
                        rel="noreferrer"
                        isExternal
                        dataTestId={item.name}
                        onClick={() => handleClickEvent(item.gaKey)}
                      >
                        {item.name}
                      </CustomLink>
                      {item.extraText && <span>{item.extraText}</span>}
                    </div>
                  )}
                </>
              ))}
          </div>
        </div>

        <div
          style={{
            borderBottom: `1px solid rgb(222, 226, 230)`,
          }}
        >
          <div
            data-testid="footer-support-section"
            className={classes.sectionHeadingMobile}
            onClick={() =>
              setisDescriptionOpen({ ...isDescriptionOpen, support: !isDescriptionOpen.support })
            }
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                setisDescriptionOpen({ ...isDescriptionOpen, support: !isDescriptionOpen.support });
              }
            }}
          >
            {t("searchpage.globalfooter.support")}
            <div
              className={
                isDescriptionOpen.support
                  ? formatClassNames(classes.chevron, classes.active)
                  : classes.chevron
              }
            >
              <Chevron />
            </div>
          </div>

          {isDescriptionOpen.support && (
            <div>
              <div className={classes.listItem}>
                <CustomLink
                  href="/help/en"
                  target="_blank"
                  rel="noreferrer"
                  isExternal
                  dataTestId="Help Center"
                  onClick={() => handleClickEvent("Help Center")}
                >
                  {helpCenterText}
                </CustomLink>
              </div>
              <div className={classes.listItem} data-testid="mobile-footer-contact">
                <script
                  type="application/ld+json"
                  nonce={nonce}
                  suppressHydrationWarning
                  dangerouslySetInnerHTML={{
                    __html: getSiteNavSchema("Contact", CONTACT_URL),
                  }}
                />
                <CustomLink
                  href="/contact"
                  target="_blank"
                  rel="noreferrer"
                  isExternal
                  dataTestId="Contact"
                  onClick={() => handleClickEvent("Contact")}
                >
                  {contactText}
                </CustomLink>
              </div>
              <div className={classes.listItem} data-testid="mobile-footer-t&c">
                <script
                  type="application/ld+json"
                  nonce={nonce}
                  suppressHydrationWarning
                  dangerouslySetInnerHTML={{
                    __html: getSiteNavSchema("Terms and Conditions", TERMS_URL),
                  }}
                />
                <CustomLink
                  href={getLocalizedPath("/terms")}
                  target="_blank"
                  rel="noreferrer"
                  isExternal
                  dataTestId="T&C"
                  onClick={() => handleClickEvent("Terms and Conditions")}
                >
                  {t("searchpage.globalfooter.termsandconditionsshort")}
                </CustomLink>
              </div>
              <div className={classes.listItem} data-testid="mobile-footer-privacy">
                <script
                  type="application/ld+json"
                  nonce={nonce}
                  suppressHydrationWarning
                  dangerouslySetInnerHTML={{
                    __html: getSiteNavSchema("Privacy Policy", PRIVACY_URL),
                  }}
                />
                <CustomLink
                  href={getLocalizedPath("/privacy")}
                  target="_blank"
                  rel="noreferrer"
                  isExternal
                  dataTestId="Privacy Policy"
                  onClick={() => handleClickEvent("Privacy Policy")}
                >
                  {privacyPolicy}
                </CustomLink>
              </div>
              <div className={classes.listItem} data-testid="mobile-footer-sitemap">
                <script
                  type="application/ld+json"
                  nonce={nonce}
                  suppressHydrationWarning
                  dangerouslySetInnerHTML={{
                    __html: getSiteNavSchema("Sitemap", SITEMAP_URL),
                  }}
                />
                <CustomLink
                  href="/sitemap"
                  target="_blank"
                  rel="noreferrer"
                  isExternal
                  dataTestId="Sitemap"
                  onClick={() => handleClickEvent("Sitemap")}
                >
                  {sitemapText}
                </CustomLink>
              </div>
            </div>
          )}
        </div>

        <div
          style={{
            borderBottom: `1px solid rgb(222, 226, 230)`,
          }}
        >
          <div
            data-testid="footer-contactUs-section"
            className={classes.sectionHeadingMobile}
            onClick={() =>
              setisDescriptionOpen({
                ...isDescriptionOpen,
                contactus: !isDescriptionOpen.contactus,
              })
            }
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                setisDescriptionOpen({
                  ...isDescriptionOpen,
                  contactus: !isDescriptionOpen.contactus,
                });
              }
            }}
          >
            {t("searchpage.globalfooter.contactus")}
            <div
              className={
                isDescriptionOpen.contactus
                  ? formatClassNames(classes.chevron, classes.active)
                  : classes.chevron
              }
            >
              <Chevron />
            </div>
          </div>

          {isDescriptionOpen.contactus && (
            <div>
              <div>
                {contactDetailsUpdated?.map((contactDetail: any) =>
                  !contactDetail.isVisibleForChina && config.IS_CHINA_APP ? (
                    <></>
                  ) : (
                    <ContactCard
                      key={contactDetail.label}
                      icon={contactDetail.icon}
                      label={contactDetail.label}
                      link={contactDetail.link}
                    />
                  ),
                )}
              </div>
              <div style={{ padding: "0 10px 10px" }}>
                {config.IS_CHINA_APP ? <FollowUsChina /> : <FollowUs isMobile />}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default wrapperHOC(FooterV2mobile, {
  componentName: "FooterV2mobile-FooterV2-Global",
  showForChina: true,
  showForMiniProgram: false,
});
